import { render } from "./FilterCategorie.vue?vue&type=template&id=5b6ccd1b"
import script from "./FilterCategorie.vue?vue&type=script&lang=js"
export * from "./FilterCategorie.vue?vue&type=script&lang=js"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__